import * as React from "react"

import { GlobalState } from "../../../../../../store"
import { collectionUrl } from "../../../../../../util/UrlGenerator"
import { useAppDispatch, useAppSelector } from "../../../../../../hooks"
import {
    collectionSelector,
    workspaceSelector,
} from "../../../../../resources/adapters"
import {
    fetchCollection,
    fetchWorkspace,
} from "../../../../../resources/thunks"

import Link from "../Link"
import UnavailableLink from "../UnavailableLink"

interface Props {
    attributes: Record<string, string>
    customLabel: string
    label: string
    collectionId: number
    workspaceId: number
}

export const CollectionInWorkspace = ({
    attributes,
    collectionId,
    customLabel,
    label,
    workspaceId,
}: Props): JSX.Element => {
    const dispatch = useAppDispatch()
    const resources = useAppSelector((state: GlobalState) => state.resources)
    const collection = collectionSelector.selectById(resources, collectionId)
    const workspace = workspaceSelector.selectById(resources, workspaceId)

    React.useEffect(() => {
        if (!collection) {
            dispatch(fetchCollection(collectionId))
        }
        if (!workspace) {
            dispatch(fetchWorkspace(workspaceId))
        }
    }, [])

    if (!collection || !workspace) {
        return (
            <UnavailableLink
                attributes={attributes}
                label={label}
                isLoading={true}
            />
        )
    } else if (collection.doesExist && workspace.doesExist) {
        const href = collectionUrl({ ...collection, workspace })

        // we only show the title if there is no custom label
        const linkLabel =
            customLabel.length > 0 ? customLabel : collection.title

        return <Link attributes={attributes} label={linkLabel} href={href} />
    }

    return <UnavailableLink attributes={attributes} label={label} />
}

export default CollectionInWorkspace
